// extracted by mini-css-extract-plugin
module.exports = {"Next":"Next_Next__1RHcd","btn":"Next_btn__1xGg0","inactive":"Next_inactive__Mxfrs","active":"Next_active__3oQuX"};